import { PropsWithChildren, ReactNode } from 'react';
import { ImagePickerAsset } from 'expo-image-picker';
import { ProfilePhotoPickerProps } from '../ProfilePhotoPicker/types';

export interface UserFields extends Pick<ProfilePhotoPickerProps, 'photoSource'> {
	id: string;
	username?: string;
	email?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	info?: string | null;
	restrictedAccess?: boolean | null;
	receiveSummaryNotificationEmails?: boolean | null;
	tags?: string[] | null;
}

export interface RenderActionsProps {
	canSubmit: boolean;
	submit: () => unknown;
}

export interface EditProfileFormProps<User extends UserFields> extends PropsWithChildren {
	user: User;
	isCareReceiver?: boolean;
	canFullyEditCareRecipient?: boolean;
	tagsInfo?: {
		canEdit: boolean;
		availableNames: string[];
	};
	renderActions: (props: RenderActionsProps) => ReactNode;
	onSubmit: (values: EditProfileFormSubmitValues) => unknown;
}

export type EditProfileFormSubmitValues = {
	inputs: {
		email?: string;
		username?: string;
		firstName?: string;
		lastName?: string;
		info?: string;
		restrictedAccess?: boolean;
		receiveSummaryNotificationEmails?: boolean;
		tags?: string[];
	};
	newPhotoAsset?: ImagePickerAsset;
	additionalInfoItems?: {
		critical: string[];
		positive: string[];
		negative: string[];
	};
};
